import SectionButtonGroup from "../../../../../../components/Button/SectionButtonGroup";
import InfoNewbornText from "./InfoNewbornText";
import InfoWatchlistText from "./InfoWatchlistText"



export default function NewbornButtonGroup() {

return(
<>      

<SectionButtonGroup

      button_1 = "IMPORTANT READ"
      button_2 = "SEQUENCING INFO"
      button_3 = "COUNSELING"
      
      title_dialog_1 = "Important Read"
      content_dialog_1 = {<InfoWatchlistText />}
      
      title_dialog_2 = "Sequencing Information"
      content_dialog_2 = {<InfoNewbornText />}

      to = "/Doctor"

/>

</>
)}